export const CNH_REGEX = /^\d{11}$/;
export const CNH_REPEATED_REGEX = /^(\d)\1{10}$/;
export const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
